import React from 'react'
import SmartMateriaUITable from '../SmartMateriaUITable'
import useNonDeletableItemsData from './hooks/useNonDeletableItemsData'

const NonDeletableItemsData = ({ domainUsageList, fullList, property }) => {
  const nonDeletableItems = useNonDeletableItemsData(domainUsageList, fullList)

  const columns = [
    {
      name: 'Resource',
      field: property?.toString() || '',
      render: (row) => row[property]
    },
    {
      name: 'Dependencies',
      field: 'dependencies',
      render: (row) => (row.dependencies ? row.dependencies.join(', ') : 'None')
    }
  ]

  return (
    <SmartMateriaUITable
      columns={columns}
      dataFetch={nonDeletableItems}
    />
  )
}

export default NonDeletableItemsData
